import { render, staticRenderFns } from "./UserInfoItem.vue?vue&type=template&id=4ad74129&scoped=true&"
import script from "./UserInfoItem.ts?vue&type=script&lang=ts&"
export * from "./UserInfoItem.ts?vue&type=script&lang=ts&"
import style0 from "./UserInfoItem.scss?vue&type=style&index=0&id=4ad74129&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad74129",
  null
  
)

export default component.exports